<template>
  <div class="serv-grid-container">
    <div>
      <img class="serv-grid-pics" src="../assets/Nursing.jpg">
    </div>

    <div class="serv-grid-content">
      <div class="serv-grid-title">
        <div>
          <router-link to="/Service/Nursing"> 
          <button class="serv-button">Nursing</button>
          </router-link>
        </div>
      </div>

      <div class="serv-grid-text">
        <p>Licensed registered nurses and nursing assistants are ALWAYS on site to ensure your health, safety and well being. They work with the family and personal physicians to develop and implement an individualized care plan.</p>
      </div>
    </div>
  </div>
 
  <div class="serv-grid-container">
    <div>
      <img class="serv-grid-pics" src="../assets/Counseling.jpg">
    </div>

    <div class="serv-grid-content">
      <div class="serv-grid-title">
        <p>Social Services</p>
      </div>

      <div class="serv-grid-text">
        <p>Certified social workers are on staff to help you navigate your way through the many intricacies of obtaining the assistance you are entitled to. We coordinate care and help families and caregivers address issues related to their family member's care.</p>
      </div>
    </div>
  </div>
  
  <div class="serv-grid-container">
    <div>
      <img class="serv-grid-pics" src="../assets/Activities.jpg">
    </div>

    <div class="serv-grid-content">
      <div class="serv-grid-title">   
        <div>
          <router-link to="/Service/Activities"> 
            <button class="serv-button">Activities</button>
          </router-link>
        </div>
      </div>

      <div class="serv-grid-text">   
        <p>Activities that promote health and wellness include games, music programming, art activities, community outings, and other activities. Programs are designed to enhance and support to maximize cognitive and social functioning.</p>
      </div>
    </div>
  </div>
    
  <div class="serv-grid-container">
    <div>
      <img class="serv-grid-pics" src="../assets/FoodInjera.jpg">
    </div>

    <div class="serv-grid-content">
      <div class="serv-grid-title">
        <p>Dietary Services</p>
      </div>

      <div class="serv-grid-text">  
        <p>We will provide a custom designed menu to suit your specific dietary health needs while maintaining cultural preferences.</p>
      </div>
    </div>
  </div> 

  <div class="serv-grid-container">
    <div>
      <img class="serv-grid-pics" src="../assets/Transportation.jpg">
    </div>

    <div class="serv-grid-content">
      <div class="serv-grid-title">
        <p>Transportation</p>
      </div>

      <div class="serv-grid-text">
        <p>We provide transportation services to those enrolled. Our trained and highly experienced drivers provide door to door escort services to assist for those using walker or cane. Every effort is made to meet the individual needs as to pick-up and drop-off times.</p>
      </div>
    </div>
  </div> 

  <router-view/>
</template>
  
<script>
  export default {
    name: 'ServiceBody'
  }

</script>
  
  
<style scoped>
   
/* for desktop */
@media (min-width:701px) {

  .serv-grid-container {
    display: grid;
    grid-template-columns: 1fr 3.5fr;
    background-color: rgb(245, 245, 245);
    border: 1px solid gray;
    padding: 0.4vw;
  }

  .serv-grid-pics {
    place-items: center;
    width: 20vw;
    height: 15vw;
    margin-left: 0.5vw;
    margin-right: 1vw;
    border: 5px solid #fff;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.5);    
  }


  .serv-grid-title {
    text-align: left;
    color: darkblue;
    font-size: 1.2rem;
    font-weight: bold;
    margin-left: 1vw;
  }

  .serv-grid-text {
    text-align: left;
    color: darkblue;
    font-size: 1.2rem;
    line-height: 2.5vw;
    margin-left: 1vw;
  }

  .serv-button {
    cursor: pointer;
    text-align: left;
    color: darkblue;
    background-color: lightblue;
    font-size: 1.2rem;
    font-weight: bold;
    border: none;
    line-height: 2.5vw;
    justify-content: top left;
    margin-top: 1.5vw;
  }
}

/* for Phone */
@media (max-width:700px) {

  img {
    width: 15rem;
    height: 10rem;
  }
  
  .serv-button {
    cursor: pointer;
    text-align: left;
    color: darkblue;
    background-color: lightblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    height: auto;
    justify-content: top left;
    margin-top: 0.5rem;
    margin-bottom: -2rem;
  }

  .serv-grid-title {
    text-align: center;
    color: darkblue;
    font-size: 1.2rem;
    font-weight: bold;

  }

  .serv-grid-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    height: auto;
    margin-top: 1rem;
    margin-bottom: 2.5rem;
  }
}

</style>